import { Box, Button, Flex, Text } from "@radix-ui/themes";
import { ChatAvatar } from "./ChatAvatar";
import moment from "moment";
import { IChannel } from "./ChannelsList";
import { ReactNode } from "react";

export function ChannelButton(props: {
  isHighlighted: boolean;
  onClick: () => void;
  hasUnread: boolean;
  avatar: ReactNode;
  title: string;
  description: string;
  timestamp?: string;
}) {
  return (
    <Box py={"2"}>
      <Button
        style={{
          cursor: "pointer",
          backgroundColor: props.isHighlighted ? "var(--accent-a3)" : undefined,
        }}
        variant={"ghost"}
        color={"gray"}
        asChild
        onClick={props.onClick}
      >
        <Flex
          width={"100%"}
          align={"center"}
          justify={"between"}
          style={{ borderBottom: "1px solid var(--gray-6)" }}
        >
          {props.hasUnread && <span className={"unreadMessages"} />}
          <Flex py={"2"} justify={"start"} width={"100%"} gap={"3"}>
            <Box pl={"1"}>{props.avatar}</Box>
            <Box>
              <Text
                weight={props.hasUnread ? "bold" : "medium"}
                align={"left"}
                as={"div"}
              >
                {props.title}
              </Text>
              <Text
                weight={props.hasUnread ? "bold" : "medium"}
                align={"left"}
                as={"div"}
                size={"1"}
              >
                {props.description}
              </Text>
            </Box>
          </Flex>
          {props.timestamp && (
            <Box>
              <Text wrap={"nowrap"}>
                {moment(props.timestamp).format("MMM D")}
              </Text>
            </Box>
          )}
        </Flex>
      </Button>
    </Box>
  );
}

export function Channel(props: {
  channel: IChannel;
  currentChannelId: IChannel["id"] | undefined;
  setCurrentChannel: (channel: IChannel | undefined) => void;
}) {
  return (
    <ChannelButton
      isHighlighted={props.currentChannelId === props.channel.id}
      onClick={() => {
        if (props.currentChannelId === props.channel.id) {
          props.setCurrentChannel(undefined);
        } else {
          props.setCurrentChannel(props.channel);
        }
      }}
      hasUnread={props.channel.has_unread}
      avatar={<ChatAvatar branding={props.channel.branding} />}
      title={props.channel.title}
      description={props.channel.description}
      timestamp={props.channel.timestamp}
    />
  );
}
